import { render, staticRenderFns } from "./NodeForm.vue?vue&type=template&id=081a50d9"
import script from "./NodeForm.vue?vue&type=script&lang=js"
export * from "./NodeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports